//init image loader
function initImageLoader() {
	return new Promise((resolve) => { // ここを追加
		const body = document.body;
		const criticalImages = [
			'./assets/images/img_intro_01.webp',
			'./assets/images/img_intro_02.webp',
			'./assets/images/img_cloud_01.webp',
			'./assets/images/img_cloud_02.webp',
			'./assets/images/img_cloud_03.webp',
			'./assets/images/img_cloud_04.webp',
			'./assets/images/img_cloud_05.webp',
			'./assets/images/img_cloud_06.webp'
		];

		const TIMEOUT_MS = 3000;
		let isApplied = false;

		const applyLoadedClass = () => {
			if (isApplied) return;
			isApplied = true;
			body.classList.add('is-loaded');
			resolve(); // これで await が解除される
		};

		const timer = setTimeout(() => {
			applyLoadedClass();
		}, TIMEOUT_MS);

		const imagePromises = criticalImages.map(src => {
			const img = new Image();
			img.src = src;
			return img.decode().catch(() => {});
		});

		Promise.all(imagePromises).then(() => {
			clearTimeout(timer);
			applyLoadedClass();
		});
	});
}

//is touch device
function isTouchDevice() {
	const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
	document.body.classList.toggle('is-touch', isTouch);
	document.body.classList.toggle('isnt-touch', !isTouch);
}

//is scroll
function isScroll() {
	let position = 0;
	let showFlag = false;
	let vh = window.innerHeight;
	const body = document.body;

	const recalc = () => {
		vh = window.innerHeight;
		position = vh * 3; 
	};

	window.addEventListener('resize', recalc);
	window.addEventListener('load', recalc);

	window.addEventListener('scroll', () => {
		const winTop = window.scrollY;
		if (winTop >= position) {
			if (!showFlag) {
				showFlag = true;
				body.classList.add('is-scroll');
			}
		} else {
			if (showFlag) {
				showFlag = false;
				body.classList.remove('is-scroll');
			}
		}
	}, { passive: true });
	recalc();
}

// navi trigger
function naviTrigger() {
	const body = document.body;
	const triggers = document.querySelectorAll('.site-navi-trigger');
	const anchors = document.querySelectorAll('.site-title__anchor, .site-navi__anchor');

	// --- 1. トリガーボタンのクリック処理 ---
	triggers.forEach(trigger => {
		trigger.addEventListener('click', (e) => {
			const target = e.currentTarget.previousElementSibling;
			body.classList.toggle('is-navi-open');
			const isOpen = body.classList.contains('is-navi-open');

			if (isOpen) {
				gsap.to(target, { scale: 1, duration: 0.3, ease: "power2.out" });
				if (window.lenisInstance) window.lenisInstance.stop();
			} else {
				gsap.to(target, { scale: 0, duration: 0.3, ease: "power2.inOut" });
				if (window.lenisInstance) window.lenisInstance.start();
			}
		});
	});

	// --- 2. アンカーリンクのクリック処理（メニュー閉鎖 + スクロール） ---
	anchors.forEach(anchor => {
		anchor.addEventListener('click', (e) => {
			e.preventDefault();
			const targetId = anchor.getAttribute('href');
			const target = (targetId === '#intro' || targetId === '#') ? 0 : document.querySelector(targetId);

			if (body.classList.contains('is-navi-open')) {
				body.classList.remove('is-navi-open');
				const siteNavi = document.querySelector('.site-navi');
				gsap.to(siteNavi, { scale: 0, duration: 0.3, ease: "power2.inOut" });
				
				if (window.lenisInstance) {
					window.lenisInstance.start();
					window.lenisInstance.scrollTo(target);
				}
			} else if (window.lenisInstance) {
				window.lenisInstance.scrollTo(target);
			}
		});
	});
}

//split text
function splitText() {
	document.querySelectorAll('.split-text').forEach(el => {
		const text = el.textContent;
		el.innerHTML = text.split('').map(char => 
			char.trim() ? `<span>${char}</span>` : char
		).join('');
	});
}

//initirized Lenis
function initLenis() {
	window.lenisInstance = new Lenis({
		duration: 1.2,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
		smoothWheel: true
	});
	window.lenisInstance.on('scroll', ScrollTrigger.update);
	gsap.ticker.add((time) => {
		window.lenisInstance.raf(time * 1000);
	});
	gsap.ticker.lagSmoothing(0);
}

//voicies link
function voiciesLink() {
	const voiciesLink = document.querySelector('.site-navi__anchor[href="#voicies"]');
	if (voiciesLink) {
		voiciesLink.addEventListener('click', (e) => {
			e.preventDefault();
			const targetEl = document.querySelector('#voicies');
			
			if (targetEl) {
				const targetPos = targetEl.getBoundingClientRect().top + window.pageYOffset;
				// 10%分（0.1）だけ余分にスクロール
				const offset = window.innerHeight * 0.1;

				if (window.lenisInstance) {
					window.lenisInstance.scrollTo(targetPos + offset);
				} else {
					window.scrollTo({
						top: targetPos + offset,
						behavior: 'smooth'
					});
				}
			}
		});
	}
}

function voiciesSlider() {
	const voiciesSlider = new Swiper('.voicies-slider', {
		loop: true,
		speed: 1000,
		allowTouchMove: true,
		effect: "creative",
		creativeEffect: {
			prev: {
				translate: [0, 0, -400],
				opacity: 0,
			},
			next: {
				translate: ["100%", 0, 0],
			},
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
			renderFraction: function (currentClass, totalClass) {
				return '<span class="' + currentClass + '"></span>' +
					' / ' +
					'<span class="' + totalClass + '"></span>';
			}
		},
	});
}

function typeSlider() {
	const typeSlider = new Swiper('.type-slider', {
		loop: true,
		speed: 1000,
		allowTouchMove: true,
		effect: "creative",
		creativeEffect: {
			prev: {
				translate: [0, 0, -400],
				opacity: 0,
			},
			next: {
				translate: ["100%", 0, 0],
			},
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});
	typeSlider.loopFix();
	typeSlider.slideToLoop(0, 0, false);
}

function vlogSlider() {
	const vlogSlider = new Swiper('.vlog-slider', {
		slidesPerView: "auto",
		centeredSlides: true,
		loop: true,
		speed: 600,
		allowTouchMove: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});
}